'use client';

import {
  FC,
  PropsWithChildren,
  createContext,
  useContext,
  useMemo,
  useState
} from 'react';

type DealerLocatorLoaderContextProps = {
  isDealerLocatorLoading: boolean;
  setIsDealerLocatorLoading: (v: boolean) => void;
};

const DealerLocatorLoaderContext =
  createContext<DealerLocatorLoaderContextProps>({
    isDealerLocatorLoading: false,
    setIsDealerLocatorLoading: () => null
  });
export const useDealerLocatorLoader = () =>
  useContext(DealerLocatorLoaderContext);

export const DealerLocatorLoaderProvider: FC<PropsWithChildren> = ({
  children
}) => {
  const [isDealerLocatorLoading, setIsDealerLocatorLoading] = useState(false);
  const dealerLocator = useMemo(
    () => ({ isDealerLocatorLoading, setIsDealerLocatorLoading }),
    [isDealerLocatorLoading, setIsDealerLocatorLoading]
  );

  return (
    <DealerLocatorLoaderContext.Provider value={dealerLocator}>
      {children}
    </DealerLocatorLoaderContext.Provider>
  );
};
